import { createAvatarWrapper } from '@/modules/misc/common/navbar/components/avatar';
import { createSwitchAccountButtons, switchAccounts } from '@/modules/misc/common/navbar/components/navbarLinks';
import { deleteChildNodes } from '@/modules/misc/common/navbar/utils/deleteChildNodes';

export function createVCAvatarDropdown({ links, user, menuFooter = null }) {
  const avatarWrapper = document.querySelector('#avatar-wrapper');

  if (!avatarWrapper) {
    return;
  }

  deleteChildNodes(avatarWrapper);

  if (links.length) {
    const avatarPlaceholder = document.querySelector('.js-avatar-menu-placeholder');

    if (avatarPlaceholder) {
      avatarPlaceholder.style.display = 'none';
    }

    avatarWrapper.appendChild(createAvatarWrapper({
      className: 'ds-header__navbar__avatar',
      user,
      links,
      dotAllowed: false,
      showDot: false,
      menuFooter,
    }));
  }

  if (user?.canSwitchAccounts) {
    const dropdown = document.querySelector('.ds-header__navbar__avatar__dropdown');
    dropdown.appendChild(createSwitchAccountButtons({ user }));
    dropdown.style.paddingBottom = '0px';

    if (user.type === 'user') {
      document.getElementById('switchToManagerAccount').addEventListener('click', switchAccounts);
    } else if (user.type === 'manager') {
      document.getElementById('switchToUserAccount').addEventListener('click', switchAccounts);
    }
  }
}
